import { Row } from "@tanstack/react-table";
import { Button, EditorIcon, ScheduleIcon, TrashcanIcon } from "@theprelude/ds";
import { useOverlay } from "@/hooks/use-overlay";
import { TestRow, ThreatRow } from "@/queries/schedule";
import { useScheduleCallback } from "./schedule-overlay/schedule-overlay";

export function ActionBar({
  selectedRows,
  type,
  onCancel,
}: {
  type: "test" | "threat";
  selectedRows: Row<ThreatRow>[] | Row<TestRow>[];
  onCancel: () => void;
}) {
  const setCallback = useScheduleCallback((state) => state.setValue);
  const overlay = useOverlay();

  if (selectedRows.length === 0) {
    return null;
  }

  const areUnscheduledRowsSelected = selectedRows.some(
    (row) => !row.original.isScheduled,
  );

  const selectedMessage =
    selectedRows.length > 1 ? `${selectedRows.length} selected` : "selected";

  const actionBarClasses =
    "w-full flex justify-end gap-x-4 absolute bg-secondary-background border-t-stroke-line px-4 py-2 border-t border-solid right-0 bottom-0";

  if (areUnscheduledRowsSelected) {
    return (
      <div className={actionBarClasses}>
        <Button onClick={onCancel} intent="secondary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            void overlay.open("schedule", {
              type,
              ids: selectedRows.map((row) => row.original.rowId),
            });
            setCallback(onCancel);
          }}
          intent="primary"
          icon={<ScheduleIcon />}
        >
          Schedule
        </Button>
      </div>
    );
  }

  return (
    <div className={actionBarClasses}>
      <Button onClick={onCancel} intent="secondary">
        Cancel
      </Button>
      <Button
        onClick={() => {
          void overlay.open("schedule", {
            type,
            ids: selectedRows.map((row) => row.original.rowId),
          });
          setCallback(onCancel);
        }}
        intent="secondary"
        icon={<EditorIcon />}
      >
        Edit {selectedMessage}
      </Button>
      <Button
        onClick={() => {
          void overlay.open("deleteSchedule", {
            type,
            ids: selectedRows.map((row) => row.original.rowId),
          });
          setCallback(onCancel);
        }}
        intent="negative"
        icon={<TrashcanIcon />}
      >
        Remove {selectedMessage} from schedule
      </Button>
    </div>
  );
}
